import axios from 'axios';
import { API_URL } from '../../../support/api';
import { PaginatedValue } from '../../../support/utils';
import { ICompanyChange } from '../models/CompanyChange';

export const BASE_COMPANY_CHANGE_URL = `${API_URL}/v1/company-change-requests`;

export const listCompanyChange = async (search = '', direction = 'asc') => {
  const URL = `${BASE_COMPANY_CHANGE_URL}/list?search=${search}&direction=${direction}`;
  const {
    data: { value },
  } = await axios.get<{ value: PaginatedValue<ICompanyChange> }>(URL);

  return value;
};

export const viewCompanyChange = async (id: number | string) => {
  const {
    data: { value },
  } = await axios.get<{ value: ICompanyChange }>(
    `${BASE_COMPANY_CHANGE_URL}/${id}/get`
  );

  return value;
};

export const deleteCompanyChange = async (payload: ICompanyChange) => {
  const {
    data: { value },
  } = await axios.post<{ value: ICompanyChange }>(
    `${BASE_COMPANY_CHANGE_URL}/${payload.id}/delete`,
    payload
  );

  return value;
};
